import { render, staticRenderFns } from "./AllRates.vue?vue&type=template&id=f017c0b0&scoped=true"
import script from "./AllRates.vue?vue&type=script&lang=js"
export * from "./AllRates.vue?vue&type=script&lang=js"
import style0 from "./AllRates.vue?vue&type=style&index=0&id=f017c0b0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f017c0b0",
  null
  
)

export default component.exports